export default __webpack_public_path__ + "static/media/mallory_compact_black.0489c0ba.ttf";